import { render, staticRenderFns } from "./RenewDocuments.vue?vue&type=template&id=5eb3835c&scoped=true"
import script from "./RenewDocuments.vue?vue&type=script&lang=js"
export * from "./RenewDocuments.vue?vue&type=script&lang=js"
import style0 from "./RenewDocuments.vue?vue&type=style&index=0&id=5eb3835c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb3835c",
  null
  
)

export default component.exports